import React from 'react';

const QIcn = {
    translate: (
        <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
            <path d="M3 5h8M7 3v2M5 5c0 4 2 7 6 8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11 13c-2 0-4-1-5-2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
            <path d="M12 17l3-7 3 7M13 14.5h4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    review: (
        <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
            <path d="M3 10l3 3 7-7" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.7" />
        </svg>
    ),
    approve: (
        <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
            <path d="M4 12l3 3 9-9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    comment: (
        <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
            <path d="M3 9a5 5 0 015-5h4a5 5 0 015 5v4a1 1 0 01-1 1H10l-4 3v-3H4a1 1 0 01-1-1V9z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
        </svg>
    ),
    glossary: (
        <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
            <path d="M4 4h9l4 4v8H4z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
            <path d="M7 9h7M7 12h7M7 15h5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
    ),
    arrow: (
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
            <path d="M2 5.5h7M6 2.5l3 3-3 3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    bolt: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M9 2L3 9h4l-1 5 6-7H8l1-5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        </svg>
    ),
    clock: (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.5" />
            <path d="M7 4.5V7l2 1.2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    ),
    star: (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M7 2l1.5 3.2 3.5.5-2.5 2.4.6 3.5L7 9.9l-3.1 1.7.6-3.5L2 5.7l3.5-.5L7 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        </svg>
    ),
    check: (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M3 7.5l2.5 2.5L11 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
};

export default QIcn;
